import React from "react";
import { Route, Redirect } from "react-router-dom";
import { isAutheticated } from "./index";

const AdminRoute = ({ component: Component, pageKey, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      const auth = isAutheticated();
      if (!auth) return <Redirect to={{ pathname: "/login", state: { from: props.location } }} />;
      const { role, allowedPages } = auth.admin;
      const isSuperAdmin = role === 1;
      const hasAccess = pageKey && Array.isArray(allowedPages) && allowedPages.includes(pageKey);
      if (isSuperAdmin || hasAccess) return <Component {...props} />;
      return <Redirect to={{ pathname: "/login", state: { from: props.location } }} />;
    }}
  />
);

export default AdminRoute;
